import I18n from "../../I18n";
import { stringifyFilter } from "colbi_web_ui/lib/utils";
import { snakeCaseToPascalCase } from "../../utils";
import { Buffer } from "buffer";
import { formatValueByType } from "./utils/formatValueByType";
import { extractEntityName, hasJsonStructure } from "./utils/mapperUtils";

function buildCardResults(tempItem, json, TypeByFieldItem, isSeverityColumn) {
    const value = json[tempItem];
    const { type, options, defaultValue, mask } = TypeByFieldItem || {};
    const defaultObj = {
        label: tempItem,
        align: TypeByFieldItem && TypeByFieldItem.align ? TypeByFieldItem.align : "left",
        basis: TypeByFieldItem.basis,
    };
    const valueByType = { ...formatValueByType(json, value, type, options, defaultValue, mask) };
    return isSeverityColumn
        ? [
              {
                  ...defaultObj,
                  value: {
                      label: valueByType.value,
                      family: "error",
                      color: "main",
                      severity: 2,
                  },
              },
          ]
        : [
              {
                  ...defaultObj,
                  ...valueByType,
              },
          ];
}

const mapCard = (json) => {
    const { TypeByField, EntityName, EntityID, DataFile } = json;
    const entityType = (EntityName || "").split("::").pop();

    const result = Object.keys(TypeByField)
        .map((item) => {
            const tempItem = item.replace("T", "F");
            const isSeverityColumn = tempItem === "F5";
            return buildCardResults(tempItem, json, TypeByField[item], isSeverityColumn);
        })
        .filter((filter) => filter);

    const colbiDDField = snakeCaseToPascalCase(entityType, "CDM_", "s");
    const idToUse = hasJsonStructure(EntityID)
        ? EntityID
        : JSON.stringify({ [`${colbiDDField}.ID`]: EntityID });

    const entityToUse = hasJsonStructure(EntityID) ? extractEntityName(EntityID) : entityType;
    const linkObj = {
        labels: ["Refers Id"],
        value: {
            id: Buffer.from(idToUse).toString("base64"),
            name: I18n.translate`${entityType}`,
            __typename: `${entityToUse}`,
        },
        type: "object",
        align: "center",
    };

    if (EntityName === "File") {
        linkObj.value[`link`] = {
            to: `/:locale(pt|en|lt|es|ro|fr)?/:projectId/repository/activity/status/?filter=${stringifyFilter(
                [{ column: "ID", filters: [{ value: `${json.ImportID}` }] }],
            )}`,
        };
    }
    result.push([linkObj]);
    result.push([{ labels: ["file"], value: DataFile, type: "string", align: "left" }]);
    return result;
};

const header = (json) => {
    const headerMapping = Object.keys(json).map((elem) => {
        if (json[elem]) {
            const { name: label, align, basis } = json[elem];
            return {
                label: [label],
                align: align ? align : "left",
                basis,
                type: elem === "T5" ? "status" : "string",
            };
        } else {
            return undefined;
        }
    });
    headerMapping.push({ label: ["reference"], align: "left", type: "object" });
    headerMapping.push({ label: ["file"], align: "left" });
    return headerMapping;
};

const mapper = (json, card) => {
    return {
        ...json,
        __typename: json.__typename,
        card: card ? mapCard(json).filter((elem) => elem.length !== 0) : [],
        detailPanel: {
            data: json.detailPanel ? json.detailPanel : undefined,
            detailPanelComponent: "AuditSchemaDetails",
        },
    };
};

const ncfindingMapper = {
    map: mapper,
    header,
    showDetailPanel: true,
    showCheckbox: true,
};

export default ncfindingMapper;
